var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.05346C11.9997 2.14427 8.30754 -0.911831 4.25633 0.2494C1.72433 0.975779 -0.00827792 3.41939 2.9746e-05 6.07347C0.00279897 6.96748 0.176337 7.80188 0.516028 8.55527L4.30156 17.9386C4.43896 18.2792 4.6739 18.5708 4.97635 18.776C5.2788 18.9813 5.63504 19.0909 5.99955 19.0909C6.36407 19.0909 6.72031 18.9813 7.02276 18.776C7.32521 18.5708 7.56015 18.2792 7.69755 17.9386L11.484 8.55527C11.8264 7.79643 11.9999 6.95474 12 6.05346ZM6.00018 3.25902C4.47342 3.25902 3.23096 4.51249 3.23096 6.05278C3.23096 7.59308 4.47342 8.84655 6.00018 8.84655C7.52695 8.84655 8.7694 7.59308 8.7694 6.05278C8.7694 4.51249 7.52695 3.25902 6.00018 3.25902Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.bac32501.svg";
export { ForwardRef as ReactComponent };